import { useState, useEffect } from 'react';
import { tenantAPI } from '../../services/api';
import toast from 'react-hot-toast';

const DAYS = [
  { key: 'monday',    label: 'Segunda-feira' },
  { key: 'tuesday',   label: 'Terça-feira' },
  { key: 'wednesday', label: 'Quarta-feira' },
  { key: 'thursday',  label: 'Quinta-feira' },
  { key: 'friday',    label: 'Sexta-feira' },
  { key: 'saturday',  label: 'Sábado' },
  { key: 'sunday',    label: 'Domingo' },
];

const DEFAULT_HOURS = {
  monday:    { open: '08:00', close: '18:00', closed: false },
  tuesday:   { open: '08:00', close: '18:00', closed: false },
  wednesday: { open: '08:00', close: '18:00', closed: false },
  thursday:  { open: '08:00', close: '18:00', closed: false },
  friday:    { open: '08:00', close: '18:00', closed: false },
  saturday:  { open: '08:00', close: '13:00', closed: false },
  sunday:    { open: '08:00', close: '13:00', closed: true  },
};

const card = { background:'#fff', borderRadius:12, padding:'24px', boxShadow:'0 1px 3px rgba(0,0,0,.08)', marginBottom:24 };
const inp  = { width:'100%', padding:'8px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, fontSize:'.9rem', outline:'none', boxSizing:'border-box' };
const lbl  = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:4, color:'#374151' };

export default function SettingsPage() {
  const [hours, setHours]           = useState(DEFAULT_HOURS);
  const [info, setInfo]             = useState({ name:'', phone:'', whatsapp:'', description:'', address:'', address_number:'', neighborhood:'', city:'', state:'', zip_code:'', latitude:'', longitude:'' });
  const [waCfg, setWaCfg]           = useState({ whatsapp_api_url:'', whatsapp_api_token:'' });
  const [colors, setColors]         = useState({ color_primary:'#2563EB', color_secondary:'#0F172A' });
  const [savingColors, setSavingColors] = useState(false);
  const [saving, setSaving]         = useState(false);
  const [savingInfo, setSavingInfo]   = useState(false);
  const [savingWa, setSavingWa]     = useState(false);
  const [loading, setLoading]       = useState(true);

  useEffect(() => {
    tenantAPI.show()
      .then(r => {
        const t = r.data.data;
        setInfo({ name: t.name || '', phone: t.phone || '', whatsapp: t.whatsapp || '', description: t.description || '', address: t.address || '', address_number: t.address_number || '', neighborhood: t.neighborhood || '', city: t.city || '', state: t.state || '', zip_code: t.zip_code || '', latitude: t.latitude || '', longitude: t.longitude || '' });
        setColors({ color_primary: t.color_primary || '#2563EB', color_secondary: t.color_secondary || '#0F172A' });
        setWaCfg({ whatsapp_api_url: t.whatsapp_api_url || '', whatsapp_api_token: t.whatsapp_api_token || '' });
        if (t.business_hours) {
          try {
            const parsed = typeof t.business_hours === 'string'
              ? JSON.parse(t.business_hours)
              : t.business_hours;
            setHours(h => ({ ...h, ...parsed }));
          } catch {}
        }
      })
      .catch(() => toast.error('Erro ao carregar configurações.'))
      .finally(() => setLoading(false));
  }, []);

  const setDay = (day, field, value) =>
    setHours(h => ({ ...h, [day]: { ...h[day], [field]: value } }));

  const saveHours = async () => {
    setSaving(true);
    try {
      await tenantAPI.update({ business_hours: hours });
      toast.success('Horários salvos com sucesso!');
    } catch {
      toast.error('Erro ao salvar horários.');
    } finally { setSaving(false); }
  };

  const saveInfo = async (e) => {
    e.preventDefault();
    setSavingInfo(true);
    try {
      await tenantAPI.update(info);
      toast.success('Dados salvos com sucesso!');
    } catch {
      toast.error('Erro ao salvar dados.');
    } finally { setSavingInfo(false); }
  };

  const saveWa = async (e) => {
    e.preventDefault();
    setSavingWa(true);
    try {
      await tenantAPI.update(waCfg);
      toast.success('Configuração WhatsApp salva!');
    } catch {
      toast.error('Erro ao salvar configuração.');
    } finally { setSavingWa(false); }
  };

  const saveColors = async (e) => {
    e.preventDefault();
    setSavingColors(true);
    try {
      await tenantAPI.update(colors);
      toast.success('Cores salvas! Atualize a landing page para ver.');
    } catch {
      toast.error('Erro ao salvar cores.');
    } finally { setSavingColors(false); }
  };

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:200 }}>
      <div style={{ color:'#6B7280' }}>Carregando...</div>
    </div>
  );

  return (
    <div>
      <h1 style={{ fontWeight:800, fontSize:'1.5rem', color:'#0F172A', marginBottom:24 }}>Configurações</h1>

      {/* Dados básicos */}
      <div style={card}>
        <h2 style={{ fontWeight:700, fontSize:'1.1rem', color:'#0F172A', marginBottom:16 }}>Dados da Empresa</h2>
        <form onSubmit={saveInfo}>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:14, marginBottom:14 }}>
            {[
              ['name',      'Nome da empresa'],
              ['phone',     'Telefone (com DDD)'],
              ['whatsapp',  'WhatsApp (com DDD)'],
            ].map(([k, l]) => (
              <div key={k}>
                <label style={lbl}>{l}</label>
                <input style={inp} value={info[k]}
                  onChange={e => setInfo(i => ({ ...i, [k]: e.target.value }))} />
              </div>
            ))}
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={lbl}>Descrição / slogan</label>
            <textarea style={{ ...inp, height:72, resize:'vertical' }}
              value={info.description}
              onChange={e => setInfo(i => ({ ...i, description: e.target.value }))} />
          </div>

          <hr style={{ border:'none', borderTop:'1px solid #E5E7EB', margin:'8px 0 16px' }} />
          <p style={{ fontWeight:700, fontSize:'.9rem', color:'#0F172A', marginBottom:12 }}>📍 Endereço (exibido no mapa da landing page)</p>
          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr', gap:14, marginBottom:14 }}>
            <div>
              <label style={lbl}>Logradouro</label>
              <input style={inp} value={info.address} placeholder="Rua, Av., etc."
                onChange={e => setInfo(i => ({ ...i, address: e.target.value }))} />
            </div>
            <div>
              <label style={lbl}>Número</label>
              <input style={inp} value={info.address_number} placeholder="123"
                onChange={e => setInfo(i => ({ ...i, address_number: e.target.value }))} />
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:14, marginBottom:14 }}>
            <div>
              <label style={lbl}>Bairro</label>
              <input style={inp} value={info.neighborhood}
                onChange={e => setInfo(i => ({ ...i, neighborhood: e.target.value }))} />
            </div>
            <div>
              <label style={lbl}>Cidade</label>
              <input style={inp} value={info.city}
                onChange={e => setInfo(i => ({ ...i, city: e.target.value }))} />
            </div>
            <div>
              <label style={lbl}>Estado (UF)</label>
              <input style={inp} value={info.state} placeholder="SP" maxLength={2}
                onChange={e => setInfo(i => ({ ...i, state: e.target.value.toUpperCase() }))} />
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:14, marginBottom:16 }}>
            <div>
              <label style={lbl}>CEP</label>
              <input style={inp} value={info.zip_code} placeholder="00000-000"
                onChange={e => setInfo(i => ({ ...i, zip_code: e.target.value }))} />
            </div>
            <div>
              <label style={lbl}>Latitude <span style={{ fontWeight:400, color:'#9CA3AF' }}>(opcional)</span></label>
              <input style={inp} value={info.latitude} placeholder="-23.5505"
                onChange={e => setInfo(i => ({ ...i, latitude: e.target.value }))} />
            </div>
            <div>
              <label style={lbl}>Longitude <span style={{ fontWeight:400, color:'#9CA3AF' }}>(opcional)</span></label>
              <input style={inp} value={info.longitude} placeholder="-46.6333"
                onChange={e => setInfo(i => ({ ...i, longitude: e.target.value }))} />
            </div>
          </div>
          <div style={{ background:'#EFF6FF', border:'1px solid #BFDBFE', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:'.8rem', color:'#1D4ED8' }}>
            💡 <strong>Dica:</strong> para o mapa mais preciso, preencha latitude e longitude. Acesse{' '}
            <a href="https://www.google.com.br/maps" target="_blank" rel="noreferrer" style={{ color:'#1D4ED8' }}>Google Maps</a>,
            clique com o botão direito no endereço e copie as coordenadas.
          </div>

          <button type="submit" disabled={savingInfo}
            style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', opacity:savingInfo ? .7 : 1 }}>
            {savingInfo ? 'Salvando...' : 'Salvar Dados'}
          </button>
        </form>
      </div>

      {/* WhatsApp API */}
      <div style={card}>
        <h2 style={{ fontWeight:700, fontSize:'1.1rem', color:'#0F172A', marginBottom:4 }}>WhatsApp Automático</h2>
        <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:16 }}>
          Configure o endpoint da sua instância Z-API, Evolution API ou similar.
          Quando uma O.S. for marcada como <strong>Finalizada</strong> ou <strong>Entregue</strong>, o cliente receberá uma mensagem automática.
        </p>
        <div style={{ background:'#F0FDF4', border:'1px solid #BBF7D0', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:'.8rem', color:'#065F46' }}>
          <strong>Como configurar:</strong> cole a URL do endpoint POST da sua instância e o token de autenticação.
          A requisição enviada será: <code style={{ background:'#dcfce7', padding:'1px 5px', borderRadius:4 }}>POST URL</code> com header
          <code style={{ background:'#dcfce7', padding:'1px 5px', borderRadius:4, marginLeft:4 }}>Authorization: Bearer TOKEN</code> e body
          <code style={{ background:'#dcfce7', padding:'1px 5px', borderRadius:4, marginLeft:4 }}>{`{"phone":"5511...", "message":"..."}`}</code>.
        </div>
        <form onSubmit={saveWa}>
          <div style={{ marginBottom:14 }}>
            <label style={lbl}>URL do endpoint (ex: https://api.z-api.io/instances/XXX/token/YYY/send-messages)</label>
            <input style={inp} value={waCfg.whatsapp_api_url}
              onChange={e => setWaCfg(w => ({ ...w, whatsapp_api_url: e.target.value }))}
              placeholder="https://..." />
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={lbl}>Token / Client-Token</label>
            <input style={inp} type="password" value={waCfg.whatsapp_api_token}
              onChange={e => setWaCfg(w => ({ ...w, whatsapp_api_token: e.target.value }))}
              placeholder="Seu token de autenticação" />
          </div>
          <button type="submit" disabled={savingWa}
            style={{ padding:'10px 24px', background:'#25D366', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', opacity:savingWa ? .7 : 1 }}>
            {savingWa ? 'Salvando...' : 'Salvar WhatsApp'}
          </button>
        </form>
      </div>

      {/* Aparência */}
      <div style={card}>
        <h2 style={{ fontWeight:700, fontSize:'1.1rem', color:'#0F172A', marginBottom:4 }}>🎨 Aparência da Landing Page</h2>
        <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:20 }}>
          As cores escolhidas aqui são aplicadas automaticamente na sua página de agendamento online.
        </p>
        <form onSubmit={saveColors}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, marginBottom:20 }}>
            <div>
              <label style={lbl}>Cor primária (botões, destaques)</label>
              <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                <input type="color" value={colors.color_primary}
                  onChange={e => setColors(c => ({ ...c, color_primary: e.target.value }))}
                  style={{ width:48, height:40, borderRadius:8, border:'1.5px solid #E5E7EB', cursor:'pointer', padding:2 }} />
                <input style={{ ...inp, flex:1 }} value={colors.color_primary}
                  onChange={e => setColors(c => ({ ...c, color_primary: e.target.value }))} />
              </div>
            </div>
            <div>
              <label style={lbl}>Cor secundária (fundo escuro, navbar)</label>
              <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                <input type="color" value={colors.color_secondary}
                  onChange={e => setColors(c => ({ ...c, color_secondary: e.target.value }))}
                  style={{ width:48, height:40, borderRadius:8, border:'1.5px solid #E5E7EB', cursor:'pointer', padding:2 }} />
                <input style={{ ...inp, flex:1 }} value={colors.color_secondary}
                  onChange={e => setColors(c => ({ ...c, color_secondary: e.target.value }))} />
              </div>
            </div>
          </div>
          {/* Prévia */}
          <div style={{ borderRadius:12, overflow:'hidden', border:'1px solid #E5E7EB', marginBottom:20 }}>
            <div style={{ background: colors.color_secondary, padding:'18px 24px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <span style={{ color:'#fff', fontWeight:800, fontSize:'1.1rem' }}>🚗 Sua Estética</span>
              <span style={{ background: colors.color_primary, color:'#fff', borderRadius:6, padding:'6px 16px', fontSize:'.85rem', fontWeight:700 }}>Agendar</span>
            </div>
            <div style={{ padding:'20px 24px', background:'#F8FAFC' }}>
              <h3 style={{ color: colors.color_secondary, fontWeight:800, marginBottom:6 }}>Título da página</h3>
              <p style={{ color:'#6B7280', fontSize:'.9rem', marginBottom:12 }}>Subtítulo descritivo aqui.</p>
              <span style={{ display:'inline-block', background: colors.color_primary, color:'#fff', borderRadius:8, padding:'8px 20px', fontSize:'.85rem', fontWeight:700 }}>Ver Serviços</span>
            </div>
          </div>
          <button type="submit" disabled={savingColors}
            style={{ padding:'10px 24px', background:'#7C3AED', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', opacity: savingColors ? .7 : 1 }}>
            {savingColors ? 'Salvando...' : '💾 Salvar Cores'}
          </button>
        </form>
      </div>

      {/* Horários de funcionamento */}
      <div style={card}>
        <h2 style={{ fontWeight:700, fontSize:'1.1rem', color:'#0F172A', marginBottom:4 }}>Horários de Funcionamento</h2>
        <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:20 }}>
          Os agendamentos online ficam disponíveis apenas dentro desses horários.
          Marque "Fechado" para bloquear um dia inteiro.
        </p>

        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {DAYS.map(({ key, label }) => {
            const dh     = hours[key] ?? {};
            const closed = dh.closed ?? false;
            return (
              <div key={key} style={{
                display:'flex', alignItems:'center', gap:12, flexWrap:'wrap',
                padding:'12px 16px', borderRadius:8,
                background: closed ? '#FEF2F2' : '#F0FDF4',
                border:`1px solid ${closed ? '#FECACA' : '#BBF7D0'}`,
              }}>
                <div style={{ width:140, fontWeight:600, fontSize:'.9rem', color:'#374151', flexShrink:0 }}>{label}</div>

                <label style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', flexShrink:0 }}>
                  <input type="checkbox" checked={closed}
                    onChange={e => setDay(key, 'closed', e.target.checked)} />
                  <span style={{ fontSize:'.85rem', color: closed ? '#DC2626' : '#6B7280' }}>Fechado</span>
                </label>

                {!closed && (
                  <div style={{ display:'flex', alignItems:'center', gap:16, flexWrap:'wrap' }}>
                    <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:'.85rem', color:'#374151' }}>
                      <span>Abre:</span>
                      <input type="time" value={dh.open ?? '08:00'}
                        onChange={e => setDay(key, 'open', e.target.value)}
                        style={{ padding:'4px 8px', border:'1.5px solid #D1FAE5', borderRadius:6, fontSize:'.85rem' }} />
                    </label>
                    <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:'.85rem', color:'#374151' }}>
                      <span>Fecha:</span>
                      <input type="time" value={dh.close ?? '18:00'}
                        onChange={e => setDay(key, 'close', e.target.value)}
                        style={{ padding:'4px 8px', border:'1.5px solid #D1FAE5', borderRadius:6, fontSize:'.85rem' }} />
                    </label>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ marginTop:20 }}>
          <button onClick={saveHours} disabled={saving}
            style={{ padding:'10px 28px', background:'#059669', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', fontSize:'.95rem', opacity:saving ? .7 : 1 }}>
            {saving ? 'Salvando...' : 'Salvar Horários'}
          </button>
        </div>
      </div>
    </div>
  );
}
